// Вкладки без конфига (HQ-1112). Вёрсткой владеет сервер: панель — config.navigation.tab_bar. Конфига нет вовсе
// (первый запуск без сети, кэш старта старше суток) — оболочка не пропадает: шапка и панель из встроенного набора,
// он повторяет tab_bar сервера по умолчанию (живой /config/ 24.10.2026: matches · leagues · favorites · news · fantasy,
// default_key matches) без fantasy: без конфига адреса мира нет, а игру может выключить сервер (HQ-1572). Подписи — наши строки (сервер присылает их переведёнными, без него — словарь). Пришёл конфиг —
// панель снова его. Последний полученный конфиг (кэш запросов в сессии, кэш старта) — раньше встроенного набора.
import type { AppConfig, TabBarItem } from '../api/types';
import { t } from '../i18n/i18n';

type TabBar = { items: TabBarItem[]; default_key?: string };

export function fallbackTabBar(): TabBar {
  return {
    items: [
      { key: 'matches', label: t('mc_matches'), icon: 'matches', url: '/api/v5/mobile/screens/cricket/matches/' },
      { key: 'leagues', label: t('mc_leagues'), icon: 'leagues', url: '/api/v5/mobile/screens/cricket/leagues/' },
      { key: 'favorites', label: t('tg_tab_favs'), icon: 'favorites', url: '/api/v5/mobile/screens/cricket/favorites/' },
      { key: 'news', label: t('mc_news'), icon: 'news', url: '/api/v5/mobile/screens/cricket/news/hub/' },
    ],
    default_key: 'matches',
  };
}

/** Запрос конфига, как его видит оболочка (подмножество useQuery). */
export interface ConfigState {
  data: AppConfig | undefined; isError: boolean; failureCount: number; fetchStatus: string;
}

/** Конфига нет и ждать его бессмысленно: запрос упал, первая попытка не удалась (идут повторы) или стоит на паузе
 *  без сети. Пока первый запрос просто идёт — оболочку не рисуем (при сети панель сразу серверная, без подмены). */
export function configUnavailable(config: ConfigState): boolean {
  if (config.data !== undefined) return false;
  return config.isError || config.failureCount > 0 || config.fetchStatus === 'paused';
}

/** Панель вкладок: из конфига (последнего полученного); конфиг недоступен — встроенная; иначе — нет (ждём ответа). */
export function tabBarOf(config: ConfigState): TabBar | undefined {
  return config.data?.navigation?.tab_bar ?? (configUnavailable(config) ? fallbackTabBar() : undefined);
}
